module.exports = __webpack_public_path__ + "img/bj_1.b90be31f.png";